import { render, staticRenderFns } from "./Recorders.vue?vue&type=template&id=514a4516"
import script from "./Recorders.vue?vue&type=script&lang=js"
export * from "./Recorders.vue?vue&type=script&lang=js"
import style0 from "./Recorders.vue?vue&type=style&index=0&id=514a4516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports